import zod from 'zod';
import { stringToBoolean, zodLimit, zodPage } from './helpers';

export const UserSchemas = {
    Account: zod.object({}),
    Password: zod.object({}),
    Sessions: zod.object({}),
    ConnectionDiagnostics: zod.object({}),
    Calendar: zod.object({}),
    OwnSupportTickets: zod.object({
        page: zodPage,
        limit: zodLimit(),
    }),
    GetOwnSupportTicket: zod.object({
        id: zod.coerce.number(),
    }),
    OwnMaintenanceRequests: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        fromDuration: zod.coerce.number().optional(),
        toDuration: zod.coerce.number().optional(),
        onlyOffline: stringToBoolean,
        onlyClosed: stringToBoolean,
        fromStart: zod.coerce.number().optional(),
        toStart: zod.coerce.number().optional(),
        fromFinish: zod.coerce.number().optional(),
        toFinish: zod.coerce.number().optional(),
        polygonType: zod.string().optional(),
        polygon: zod.coerce.number().optional(),
        orderBy: zod.string().optional(),
        orderDirection: zod.enum(['asc', 'desc']),
    }),
    GetOwnMaintenanceRequest: zod.object({
        id: zod.coerce.number(),
    }),
    Notes: zod.object({}),
} as const;
